import React, { useState, useEffect } from 'react';
import {
  Box,
  CssBaseline,
  Container,
  Card,
  CardContent,
  CardActions,
  Menu,
  MenuItem,
  Button,
  TextField,
  FormControl, InputLabel, Select,
  Grid,IconButton as IconButton,
  CircularProgress, // Import a loading spinner from Material-UI
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import AuthApi4 from "../services/authApi";
import Navbar from "../sidebar/SideNavbar";
import setTopBox from "../images/stb_new.jpeg";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

export default function SubscriptionManagement() {
  const [menuInfo, setMenuInfo] = useState({ anchorEl: null, stbNumber: null, stbId: null, index: null });
  const [stbData, setStbData] = useState([]);
  const [stbNumber, setStbNumber] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);  // Add a loading state
  const navigate = useNavigate();

  useEffect(() => {
    stbinfoNew();
  }, []); // Fetch data when the component is mounted

  const stbinfoNew = async () => {
    setLoading(true); // Set loading to true when starting to fetch
    let data = {
      records: [
        {
          operator_id: parseInt(localStorage.getItem("ownerId")),
          CUST_ID: localStorage.getItem("payment_cust_num"),
          type: "subMngmnt"
        },
      ],
    };
    console.log(data);
    await AuthApi4.stbinfo(data)
      .then((response) => {
        console.log(response);
        setStbData(response.data.stbdetails);
        setLoading(false); // Set loading to false once data is fetched
        console.log(response.data.stbdetails);
      })
      .catch((e) => {
        setLoading(false); // Stop loading even on error
        console.log("STB INFO Error");
        console.log(e);
      });
  };

  const handleFilterChange = async (newStb, newStatus) => {
    // const newStbNumber = event.target.value;
    // setStbNumber(newStbNumber);
    setLoading(true); // Start loading for filtering as well
    let data = {
      records: [
        {
          operator_id: parseInt(localStorage.getItem("ownerId")),
          CUST_ID: localStorage.getItem("payment_cust_num"),
          type: "FILTER",
          stb_number:newStb ?? "",
          s_status: newStatus ?? ""
        },
      ],
    };
    console.log("data",data);
    await AuthApi4.stbinfo(data)
      .then((response) => {
        console.log(response);
        setStbData(response.data.stbdetails);
        setLoading(false); // Stop loading after filtering
        console.log(response.data.stbdetails);
      })
      .catch((e) => {
        setLoading(false); // Stop loading on error
        console.log("STB INFO Error");
        console.log(e);
      });
    
  };

  const handleClickMenu = (event, stbNumber, stbId, index) => {
    setMenuInfo({ anchorEl: event.currentTarget, stbNumber, stbId, index });
  };

  const handleClickModify = () => {
    const stbIdsArray = Array.isArray(menuInfo.stbId)
      ? menuInfo.stbId.map(item => item) 
      : [menuInfo.stbId];  

    navigate('/bulkModify', { state: { stbId: stbIdsArray } });
  };

  const handleClickRenew = () => {
    navigate('/renew', { state: { stbNumber: menuInfo.stbNumber } });
  };

  const handleClickAddChannel = () => {
    navigate('/addChannel', { state: { stbId: menuInfo.stbId } });
  };
 const handleClickRetrack = async (stbId) => {
  try {
    const operatorId = parseInt(localStorage.getItem("ownerId"));

    if (!operatorId || !stbId) {
      alert("Missing operator ID or STB ID");
      return;
    }

    const payload = {
      operator_id: operatorId,
      STB_ID: stbId,
      cluster: "retrackSTB",
      url: "https://nxtvendorapi.nxtdigital.in/prod/external/lco/v1"
    };

    console.log("Retrack Payload:", payload);

    const response = await fetch("https://api.mobiezy.in/service2/NXT_IMPORT", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const data = await response.json();
    console.log("Retrack API Response:", data);

    if (response.ok) {
      alert("Retrack request sent successfully!");
    } else {
      alert("Retrack failed: " + data.message);
    }

  } catch (error) {
    console.error("Error in Retrack:", error);
    alert(error.message);
  }
};


const handleRefresh = async () => {
  setLoading(true);

  let payload = {
    PHONE: localStorage.getItem("phoneNumber"),
    operator_id: parseInt(localStorage.getItem("ownerId")),
    "FLAG":"A"
  };

  try {
    const response = await fetch(
      "https://api.mobiezy.in/php/NXTV2/hotel_import.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      }
    );

    let json = await response.json();
    console.log("REFRESH API RESPONSE", json);

    // set BULK_IMPORTED flag
    localStorage.setItem("BULK_IMPORTED", "Y");

    // reload STB list
    await stbinfoNew();

    Swal.fire({
      icon: "success",
      title: "Refreshed Successfully!",
      timer: 1200,
      showConfirmButton: false
    });

  } catch (error) {
    console.log("REFRESH API ERROR", error);

    Swal.fire({
      icon: "error",
      title: "Failed to Refresh!"
    });

    setLoading(false);
  }
};
const getRemainingDays = (expiryDate) => {
  if (!expiryDate) return 0;

  const today = new Date();
  const exp = new Date(expiryDate);

  // Calculate difference in milliseconds
  const diffTime = exp - today;

  // Convert to days
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
};

  const handleClickCancel= async(event) => {
    let stbId= menuInfo.stbId;
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to Cancel Box?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: {
        popup: 'small-swal-popup', 
      },
    });

    if (result.isConfirmed) {
      setLoading(true); 
      let data = {
          operator_id: parseInt(localStorage.getItem("ownerId")),
          CUST_ID: localStorage.getItem("payment_cust_num"),
          stb_id: stbId
      };

      console.log(data);

      await AuthApi4.cancelSTB(data)
      .then((response) => {
        console.log(response);
        setLoading(false);
        if (response.data.p_out_mssg_flg === 'S') {
          Swal.fire({
            icon: 'success',
            title: 'Box Cancelled Successfullly',
            // text: 'The total amount must be greater than zero to renew the pack.',
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
          return; 
        }else{
          Swal.fire({
            icon: 'error',
            title: 'Cancellation Failed',
            text: response.data.p_out_mssg || 'An error occurred while Cancelling Box.',
          });
          return; 
        }
      })
      .catch((e) => {
        setLoading(false);
        console.log("Single Cancellation API Error");
        console.log(e);
      });
    }
  };

  const handleCloseMenu = () => {
    setMenuInfo({ anchorEl: null, stbNumber: null, stbId: null, index: null });
  };

 return (
  <div style={{ display: "flex", background: "#F5F5F5" }}>
    <CssBaseline />
    <Navbar />

    <main style={{ flexGrow: 1 }}>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          margin: 'auto',
          minHeight: '100vh',
          padding: 10
        }}
      >

        {/* Filters */}
         <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
        
                    {/* LEFT SIDE */}
                    <Button
                        variant="contained"
                        sx={{
                        backgroundColor: "#ff8c00",
                        color: "#fff",
                        height: "55px",
                        '&:hover': { backgroundColor: "#ffad42" }
                        }}
                      onClick={handleRefresh}
                    >REFRESH</Button>
                   
        
                    {/* RIGHT SIDE (Input + Dropdown) */}
                    <Box sx={{ display: "flex", gap: 2, width: "70%", justifyContent: "flex-end" }}>
                      
                      {/* STB Number Search */}
                     <TextField
                        sx={{ width: "40%" }}
                        label="ID/STB Number"
                        variant="outlined"
                        value={stbNumber}
                        onChange={(e) => {
                          setStbNumber(e.target.value);
                          handleFilterChange(e.target.value, status);
                        }}
                        InputProps={{
                          endAdornment: (
                            stbNumber && (
                              <IconButton
                                onClick={() => {
                                  setStbNumber("");
                                  handleFilterChange("", status);
                                }}
                                edge="end"
                              >
                                <CloseIcon />
                              </IconButton>
                            )
                          )
                        }}
                      />

        
                      {/* Status Dropdown */}
                      <FormControl sx={{ width: "40%" }}>
                        <InputLabel>Status</InputLabel>
                        <Select
                          value={status}
                          label="Status"
                          onChange={(e) => {
                            setStatus(e.target.value);
                            handleFilterChange(stbNumber, e.target.value);
                          }}
                        >
                          <MenuItem value="">Select</MenuItem>
                          <MenuItem value="Active">Active</MenuItem>
                          <MenuItem value="Suspended">Suspended</MenuItem>
                        </Select>
                      </FormControl>
                      <div>
                        <h5>Total Boxes: {stbData.length}</h5>
                      </div>   
        
                    </Box>
        
                  </Box>


      
        {/* Main Data */}
        <Grid container spacing={1} style={{ marginTop: '2px' }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '20px' }}>
              <CircularProgress />
            </Box>
          ) : Array.isArray(stbData) && stbData.length > 0 ? (
            stbData.map((item, index) => {
              const remainingDays = getRemainingDays(item.PRE_END_DATE);

              return (
                <Grid item xs={12} md={4} key={index}>
                  <Card
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      backgroundColor: '#f5f5f5',
                      borderRadius: 4,
                      boxShadow: 6,
                    }}
                  >

                    {/* ID Header */}
                    <Grid container style={{ width: '100%' }}>
                      <Grid item xs={12} style={{ padding: '10px' }}>
                        <p style={{ fontSize: '1rem', margin: '0' }}>
                          <strong>ID: </strong>
                          <strong style={{ color: '#ff8c00' }}>
                            {item.CUSTOMER_ID}
                          </strong>
                        </p>
                      </Grid>
                    </Grid>

                    {/* Body */}
                    <Grid container style={{ width: '100%', minHeight: '160px', margin: 0 }}>
                      <Grid item xs={5} style={{ padding: '6px' }}>
                        <img
                          src={setTopBox}
                          alt="Set-Top Box"
                          style={{ width: '85%', maxHeight: '100px', objectFit: 'contain' }}
                        />
                      </Grid>

                      <Grid item xs={7} style={{ display: 'flex', flexDirection: 'column' }}>
                        <CardContent style={{ flexGrow: 1, padding: 0 }}>
                          <p style={{ fontSize: '0.65rem' }}>
                            STB Number: <strong>{item.STB_NUMBER}</strong>
                          </p>
                          <p style={{ fontSize: '0.65rem' }}>
                            VC Number: <strong>{item.VC_NUMBER}</strong>
                          </p>
                          <p style={{ fontSize: '0.65rem' }}>
                            Pack Amount: <strong>{item.sub_total}</strong>
                          </p>
                          <p style={{ fontSize: '0.65rem' }}>
                            Status:
                            <strong>
                              <span style={{ color: item.STATUS === "Active" ? "green" : "red" }}>
                                {item.STATUS}
                              </span>
                            </strong>
                          </p>
                          <p style={{ fontSize: '0.65rem' }}>
                            Expiry Date:
                            <strong>
                              {moment(item.PRE_END_DATE).utc().format('DD-MM-YYYY')}
                            </strong>
                          </p>
                        </CardContent>

                        {/* Actions */}
                        <CardActions style={{ justifyContent: 'flex-end', paddingBottom: 10 }}>
                          <Button
                            onClick={(event) =>
                              handleClickMenu(event, item.STB_NUMBER, item.STB_ID, index)
                            }
                            sx={{
                              backgroundColor: '#ff8c00',
                              color: '#fff',
                              fontSize: '0.7rem',
                              padding: '4px 8px',
                              '&:hover': { backgroundColor: '#ffad42' },
                            }}
                          >
                            Action <ArrowDropDownIcon sx={{ ml: 1 }} />
                          </Button>

                          {/* MENU */}
                          <Menu
                            anchorEl={menuInfo.index === index ? menuInfo.anchorEl : null}
                            open={menuInfo.index === index}
                            onClose={handleCloseMenu}
                          >
                            {item.STATUS === "Active" ? (
                              <>
                                {remainingDays <= 26 && (
                                  <MenuItem onClick={handleClickRenew}>Renew</MenuItem>
                                )}

                                <MenuItem onClick={handleClickAddChannel}>Add Channel</MenuItem>

                                <MenuItem onClick={() => handleClickRetrack(item.STB_ID)}>
                                  Retrack
                                </MenuItem>

                                {localStorage.getItem("cancel_status") === "y" && (
                                  <MenuItem onClick={handleClickCancel}>Cancel</MenuItem>
                                )}
                              </>
                            ) : item.sub_total > 0 ? (
                              <>
                                {remainingDays <= 5 && (
                                  <MenuItem onClick={handleClickRenew}>Renew</MenuItem>
                                )}

                                <MenuItem onClick={() => handleClickRetrack(item.STB_ID)}>
                                  Retrack
                                </MenuItem>

                                {remainingDays <= 5 && (
                                  <MenuItem onClick={handleClickModify}>Modify</MenuItem>
                                )}
                              </>
                            ) : (
                              <>
                                {remainingDays <= 5 && (
                                  <MenuItem onClick={handleClickModify}>Modify</MenuItem>
                                )}
                              </>
                            )}
                          </Menu>
                        </CardActions>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              );
            })
          ) : (
            <p>No data available</p>
          )}
        </Grid>
      </Container>
    </main>
  </div>
)
}
